module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl3-100.2329cc96.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl3-100.png
// module id = 3558
// module chunks = 11